var MAIN = (function(MAIN, $, window, document, undefined){
  var ua = navigator.userAgent;

  MAIN.isTouchDevice = ('ontouchstart' in document.documentElement);
  MAIN.isiPad = (ua.match(/iPad/i) !== null);
  MAIN.isiPhone = (navigator.platform.indexOf('iPhone') !== -1) || (navigator.platform.indexOf('iPod') !== -1);
  MAIN.isAndroid = (ua.indexOf('Android') !== -1);

  MAIN.isLocalEnv = function(){
    if (!window || !window.location) return false;
    var protocol = window.location.protocol;
    var host = (window.location.hostname || '').toLowerCase();
    if (protocol === 'file:') return true;
    // Treat the live domain as "not local". Everything else is considered local/non-live.
    // This intentionally includes staging/preview domains in "local" so tracking/geo-ip are suppressed there too.
    return !(host === 'branding48.com' || host.endsWith('.branding48.com'));
  }

  MAIN.fireOnce = function(key, fn){
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');
    fn();
  }

  function tooltip() {
    if (typeof tippy === 'undefined'){
      return;
    }

    // Keep tooltip triggers from acting like hash links.
    $('body').on('click', '.tip', function(e){
      e.preventDefault();
    });

    tippy('.tip', {
      content(reference) {
        return reference.getAttribute('data-tooltip');
      }
    });
  }

  function faq(){
    function closeFaq($faq){
      var $answer = $faq.find('.answer');
      var answerEl = $answer.get(0);
      if (!answerEl) {
        return;
      }
      $answer.off('transitionend.faq');
      $answer.css('height', answerEl.scrollHeight + 'px');
      $faq.addClass('closing');
      requestAnimationFrame(function(){
        $answer.css('height', 0);
        $faq.removeClass('open');
      });
      $answer.on('transitionend.faq', function(ev){
        if (ev.target !== answerEl) {
          return;
        }
        $answer.off('transitionend.faq');
        $answer.css('height', '');
        setTimeout(function(){
          $faq.removeClass('closing');
        }, 450);
      });
    }

    function openFaq($faq){
      var $answer = $faq.find('.answer');
      var answerEl = $answer.get(0);
      if (!answerEl) {
        return;
      }
      $answer.off('transitionend.faq');
      $answer.css('height', answerEl.scrollHeight + 'px');
      $faq.addClass('open');
      $answer.on('transitionend.faq', function(ev){
        if (ev.target !== answerEl) {
          return;
        }
        $answer.off('transitionend.faq');
        $answer.css('height', 'auto');
      });
    }

    $('body').on('click', '.faq .js-subject', function(e){
      e.preventDefault();
      var $faq = $(this).parent();
      var isOpen = $faq.hasClass('open');
      var $subject = $(this);
      var subjectText = ($subject.text() || '').trim();
      var subjectId = $subject.attr('id') || '';

      $('.faq.open').not($faq).each(function(){
        closeFaq($(this));
      });

      if (isOpen) {
        closeFaq($faq);
      } else {
        openFaq($faq);
        // Track FAQ clicks
        if (!MAIN.isLocalEnv()){
          if (typeof gtag === 'function'){
            gtag('event', 'faq_click', {
              event_category: 'engagement',
              event_label: subjectId ? subjectId + ': ' + subjectText : subjectText
            });
          }
        }
      }
    });
  }

  function expandToggle(){
    $('body').on('click', '.expand-toggle', function(e){
      e.preventDefault();
      var $toggle = $(this);
      var $target = $toggle.siblings('.expandable').first();
      if (!$target.length) {
        $target = $toggle.closest('li').find('.expandable').first();
      }
      $toggle.toggleClass('active');
      $target.toggleClass('active');
    });
  }

  function trackQualifiedEngagement(){
    var interacted = false;
    var isLocal = MAIN.isLocalEnv();

    function markInteraction(){
      interacted = true;
      window.removeEventListener('scroll', markInteraction);
      window.removeEventListener('click', markInteraction);
    }
    window.addEventListener('scroll', markInteraction, { passive: true });
    window.addEventListener('click', markInteraction);

    setTimeout(function(){
      if (!interacted) {
        return;
      }
      try {
        MAIN.fireOnce('qualified_engagement', function(){
          // Don't track engagement if we're on the local environment.
          if (isLocal) return;

          if (typeof gtag === 'function'){
            gtag('event', 'qualified_engagement', {
              event_category: 'engagement',
              value: 12
            });
          }
          if (window.fbq) {
            fbq('trackCustom', 'QualifiedEngagement');
          }
        });
      } catch (e) {}
    }, 12000);
  }

  function testimonialSlider(){
    var $wrap = $('#testimonial-slider-wrap');
    var $slider = $('#testimonial-slider');
    if (!$slider.length || typeof $.fn.bxSlider !== 'function') {
      return;
    }

    var $progressBar = null;
    var slider = null;
    var lastViewportWidth = $(window).width();

    function restartProgressBar(){
      if (!$progressBar || !$progressBar.length) {
        return;
      }
      var barEl = $progressBar.get(0);
      $progressBar.removeClass('is-animating');
      void barEl.offsetWidth;
      $progressBar.addClass('is-animating');
      $progressBar.css('animation-play-state', 'running');
    }

    function pauseProgressBar(){
      if ($progressBar && $progressBar.length){
        $progressBar.css('animation-play-state', 'paused');
      }
    }

    var sliderOptions = {
      auto: true,
      autoHover: true,
      pause: 6000,
      controls: false,
      pager: false,
      speed: 450,
      slideSelector: '.testimonial-card',
      minSlides: 1,
      maxSlides: 1,
      moveSlides: 1,
      touchEnabled: false,
      randomStart: true,
      onSliderLoad: restartProgressBar,
      onSlideBefore: restartProgressBar
    };

    var pauseMs = sliderOptions.pause || 6000;
    var $progress = $('<div class="testimonial-progress" aria-hidden="true"><div class="testimonial-progress__bar"></div></div>');
    $progress.css('--testimonial-pause', (pauseMs / 1000) + 's');
    $progressBar = $progress.find('.testimonial-progress__bar');
    var $controls = $('.bx-controls', $wrap);
    if ($controls.length) {
      $progress.insertBefore($controls.first());
    } else {
      $wrap.append($progress);
    }

    slider = $slider.bxSlider(sliderOptions);

    var resizeTimer = null;
    var $hoverTargets = $wrap.add($progress);

    function restartAuto(){
      slider.stopAuto();
      pauseProgressBar();
      slider.startAuto();
      restartProgressBar();
    }

    $('.prev', $wrap).on('click', function(e){
      e.preventDefault();
      restartAuto();
      slider.goToPrevSlide();
    });

    $('.next', $wrap).on('click', function(e){
      e.preventDefault();
      restartAuto();
      slider.goToNextSlide();
    });

    $hoverTargets.on('mouseenter', function(){
      if (slider){
        slider.stopAuto();
      }
      pauseProgressBar();
    }).on('mouseleave', function(){
      if (slider){
        slider.startAuto();
      }
      restartProgressBar();
    });

    $(window).on('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function(){
        var vw = $(window).width();
        if (vw === lastViewportWidth) {
          return;
        }
        lastViewportWidth = vw;
        if (typeof slider.reloadSlider === 'function'){
          slider.reloadSlider(sliderOptions);
          slider.startAuto();
          restartProgressBar();
        }
      }, 180);
    });
  }

  function featuresSlider(){
    var $wrap = $('#features-slider-wrap');
    var $slider = $('#features-slider');
    if (!$slider.length || typeof $.fn.bxSlider !== 'function') {
      return;
    }

    var resizeTimer = null;
    var lastViewportWidth = $(window).width();

    function getOptions(){
      var vw = $(window).width();
      var slideWidth = vw >= 1400 ? 520 :
        vw >= 1100 ? 460 :
        vw >= 900  ? 400 :
        vw >= 700  ? 340 : 285;
      var slideMargin = vw >= 1100 ? 28 : vw >= 700 ? 20 : 16;
      var maxSlides = vw >= 1200 ? 3 : vw >= 768 ? 2 : 1;

      return {
        auto: false,
        infiniteLoop: false,
        pager: false,
        controls: false,
        speed: 1000,
        slideSelector: '.card-features',
        slideWidth: slideWidth,
        minSlides: 1,
        maxSlides: maxSlides,
        moveSlides: 2,
        slideMargin: slideMargin,
        touchEnabled: false
      };
    }

    var sliderOptions = getOptions();
    var slider = $slider.bxSlider(sliderOptions);

    $('.prev', $wrap).on('click', function(e){
      e.preventDefault();
      slider.goToPrevSlide();
    });

    $('.next', $wrap).on('click', function(e){
      e.preventDefault();
      slider.goToNextSlide();
    });

    $(window).on('resize', function(){
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function(){
        var vw = $(window).width();
        if (vw === lastViewportWidth) {
          return;
        }
        lastViewportWidth = vw;
        sliderOptions = getOptions();
        if (typeof slider.reloadSlider === 'function'){
          slider.reloadSlider(sliderOptions);
        }
      }, 180);
    });
  }

  function footer(){
    $('#footer-year').text(new Date().getFullYear()).parent().css('opacity', 1);
  }

  function lazyload(){
    if (!(typeof $.fn.lazyload === 'function' || typeof window.lazyload === 'function')) {
      return;
    }
    var $targets = $('img[data-src], img[data-srcset]');
    if (!$targets.length){
      return;
    }

    $targets.each(function(){
      var $img = $(this);
      if (!$img.hasClass('lazyload')){
        $img.addClass('lazyload');
      }
      if (!$img.attr('loading')){
        $img.attr('loading', 'lazy');
      }
    });

    var options = {
      rootMargin: '300px 300px',
      threshold: 0.01,
      src: 'data-src',
      srcset: 'data-srcset'
    };
    $targets.lazyload(options);
  }

  function shineButton(){
    $('body').on('mousemove', '.btn-primary.shine', function (e) {
      var $button = $(this);
      var rect = $button.get(0).getBoundingClientRect();
      $button.get(0).style.setProperty("--x", e.clientX - rect.x);
      $button.get(0).style.setProperty("--y", e.clientY - rect.y);
    });
  }

  function trackOrderTrigger(){
    $('body').on('click', '.order-trigger', function(e){
      // Track the order button click event.
      if (!MAIN.isLocalEnv()){
        try {
          // Fire only once per session (not once ever).
          MAIN.fireOnce('order_button_click', function(){
            if (typeof gtag === 'function'){
              gtag('event', 'order_button_click', {
                event_category: 'intent',
                event_label: 'order_cta'
              });
            }
            if (window.fbq) {
              fbq('trackCustom', 'OrderButtonClick');
            }
          });
        } catch (err) {}
      }
    });
  }

  // Trigger a pricing view event when the pricing section
  // is viewed for X seconds.
  function firePricingView(){
    try {
      MAIN.fireOnce('pricing_view', function(){
        if (typeof gtag === 'function'){
          gtag('event', 'pricing_view', {
            event_category: 'intent',
            event_label: 'pricing_section'
          });
        }
        if (window.fbq) {
          fbq('trackCustom', 'ViewPricing');
        }
      });
    } catch (e) {}
  }

  // Track pricing section dwell via NAV helper
  function trackPricingVisibility(){
    // Don't track pricing view if we're on the local environment.
    if (MAIN.isLocalEnv()) return;

    var el = $('#packages');
    if (!el.length) return;
    NAV.observeVisibilityDuration(el, {
      threshold: 0.01,
      duration: 4000,
      onReached: firePricingView
    });
  }

  function logoTicker(){
    var $track = $('.logo-ticker__track');
    if (!$track.length) return;

    function pauseLogoTickerWhenHidden(){
      var $tickers = $('.logo-ticker');
      if (!$tickers.length) return;
      if (!('IntersectionObserver' in window)) return;

      var obs = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          var el = entry.target;
          if (!el) return;
          if (entry.isIntersecting) {
            el.classList.remove('is-paused');
          } else {
            el.classList.add('is-paused');
          }
        });
      }, { threshold: 0.2 });

      $tickers.each(function(_, el){
        obs.observe(el);
      });
    }

    // Guard: only clone if we don't already have 2 sequences.
    var $seq = $track.children('.logo-ticker__seq');
    if ($seq.length >= 2) return;
    if (!$seq.length) return;

    var $clone = $seq.first().clone(false);
    $clone.attr('aria-hidden', 'true');
    $track.append($clone);

    pauseLogoTickerWhenHidden();
  }

  function chat(){
    // Load chat widget script after the full page has loaded
    var isLoadedOrScheduled = false;
    var isFileProtocol = !!(window.location && window.location.protocol === 'file:');

    function getAssetPath(path){
      return isFileProtocol ? ('assets/' + path) : ('/assets/' + path);
    }

    function loadChatWidgetScript(){
      if (isLoadedOrScheduled) return;
      isLoadedOrScheduled = true;

      // If the widget is already on the page, don't load again.
      if (document.querySelector && document.querySelector('[data-chat-widget]')) {
        return;
      }
      if (document.querySelector && document.querySelector('script[data-chat-widget-script]')) {
        return;
      }

      var s = document.createElement('script');
      s.async = true;
      s.src = getAssetPath('js/chatbot.js') + '?v=' + Date.now();
      s.setAttribute('data-chat-widget-script', '1');
      (document.head || document.body || document.documentElement).appendChild(s);
    }

    function schedule(){
      window.setTimeout(loadChatWidgetScript, 500);
    }

    if (document.readyState === 'complete') {
      schedule();
    } else if (window.addEventListener) {
      window.addEventListener('load', schedule);
    } else if (window.attachEvent) {
      window.attachEvent('onload', schedule);
    }
  }

  function koalendar(){
    $('.link-koalendar')
      .each(function(){
        $(this).css('display', 'inline-block');
      })
      .on('click', function(){
        if (!MAIN.isLocalEnv()){
          if (typeof gtag === 'function'){
            gtag('event', 'koalendar_link_click', {
              event_category: 'engagement',
              event_label: 'Koalendar link click'
            });
          }
        }
      });
  }

  function teaserExampleLinks(){
    $('body').on('click', '.js-teaser-example-link', function(e){
      if (!MAIN.isLocalEnv()){
        if (typeof gtag === 'function'){
          gtag('event', 'teaser_example_link_click', {
            event_category: 'engagement',
            event_label: $(this).text()
          });
        }
        if (window.fbq) {
          fbq('trackCustom', 'BrandKitExampleLinkClick', {
            event_label: $(this).text()
          });
        }
      }
    });
  }

  $(function(){
    tooltip();
    expandToggle();
    testimonialSlider();
    featuresSlider();
    faq();
    footer();
    logoTicker();
    lazyload();
    shineButton();
    trackQualifiedEngagement();
    trackOrderTrigger();
    trackPricingVisibility();
    chat();
    koalendar();
    teaserExampleLinks();
  });

  return MAIN;
})(window.MAIN || {}, jQuery, window, document);
